exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tutor-slide-notes-container[data-v-125b9e3e]{position:sticky;margin:auto;bottom:0;width:50%}.toggleNoteContainer[data-v-125b9e3e]{text-align:center}#toggleNoteViewer[data-v-125b9e3e]{background:#009fd9;color:#fff;text-align:center;position:relative;top:7px;font-size:16px;padding:0;width:120px;height:22px}#tutor-slide-notes[data-v-125b9e3e]{border-radius:10px 10px 0 0;text-align:center;margin:auto;font-size:12px;background-color:#fff;border-left:8px solid #009fd9;border-color:#009fd9 #009fd9 currentcolor;border-right:8px solid #009fd9;border-top:8px solid #009fd9;max-height:250px;overflow-y:scroll;padding:12px}", ""]);

// exports
